/* eslint-disable react/jsx-wrap-multilines */
import React, {useEffect, useRef, useState} from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import {
    Button,
    TextField,
    CircularProgress, DialogTitle, DialogActions, Dialog, DialogContent, Autocomplete, Stack
} from '@mui/material';
import {Box, Grid, ListItemText, MenuItem, Typography} from "@mui/material";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {PrevTestaForm, VMPrevList, VMPrevListApiResponse} from "./types";
import {useCreatePrevTesta, useGetClientiDTO, useGetVMPrev} from "./Services";



interface PreventiviAddProps {
  onClose: () => void;
  propflgtemp: string;
}

// const PreventiviAdd  = ()  => {
const PreventiviAdd: React.FC<PreventiviAddProps> = ({ onClose,propflgtemp }) => {

   const validationSchema = Yup.object().shape({
                idcli: Yup.string(),
                codprev: Yup.string(),
                codcli : Yup.number(),
                codditta :Yup.number(),
                note :Yup.string(),
                desprev :Yup.string(),
                numord :Yup.string(),
                // codref :Yup.string(),
                flgtemp :Yup.string(),
                codprog :Yup.string(),
                flgval :Yup.string(),
                idvmprev :Yup.number(),
                dataprev: Yup.date()
                        .nullable()
                        .transform((value, originalValue) => {
                            if (originalValue === "") {
                                return undefined; // Convert empty string to null
                            }
                            return value;
                        })
                        .typeError("Data preventivo deve essere una data valida"),
               });

  const { mutateAsync: createPrevTesta, isPending: isCreatingPrevTesta } = useCreatePrevTesta();

  const { setValue, register,control, handleSubmit, formState: { errors },reset,watch} = useForm({ resolver: yupResolver(validationSchema)})
  const [idcli, setIdCli] = useState('0');
  const [codditta, setCodDitta] = useState(2);
  const [flgtemp, setFlgTemp] = useState('N');
  const [flgval, setFlgVal] = useState('Y');
  const [dataprev, setDataPrev] = useState('');

  const [idvmprev, setIdVMPrev] = useState(0);

   const role = localStorage.getItem('keyrole') || '';


   let coddip = localStorage.getItem('coddip') || 'NN';
   let impcoddip = localStorage.getItem('impcoddip') || 'NN';
   let isAdmin = false;


   if (role.includes('TimeReportPreventivi')) {
                                coddip = (impcoddip === 'NN' || impcoddip === '') ? '' : impcoddip;
                                isAdmin = true;
                                        }






  const {  data: ClientiDTOApiResponse, refetch  } = useGetClientiDTO(codditta);

        useEffect(() => {
            setIdCli('0');  // Reset selected client when ditta changes
            refetch();      // Re-fetch clients based on new ditta
        }, [codditta, refetch]);

  const handleCliente = (idcli: string) => {
       // console.log('Value changed:', value);
       // console.log(sociRicApiResponse);
      if (idcli) {
          setValue('idcli', idcli);
          setIdCli(idcli);
          }
     //   reset();
  };

  const {  data: VMPrevApiResponse } = useGetVMPrev();

  // console.log('VMPrevApiResponse:', VMPrevApiResponse);

  // const handleVMPrev = (idcli: string) => {
  //     if (idvmprev) {
  //         setValue(idvmprev, idvmprev);
  //         setIdVMPrev(idvmprev);
  //         }
  //    //   reset();
  // };






  const clickedButtonRef = useRef<string | null>(null);

  const handleButtonClick = (buttonId: string) => {
        clickedButtonRef.current = buttonId;
      };


 const onSubmit: SubmitHandler<PrevTestaForm> = async (data) => {


      if (clickedButtonRef.current === 'save') {
          if (!data.flgtemp) {
              data.flgtemp = 'N';
          }
          data.coddip = localStorage.getItem('coddip') || '';
           await createPrevTesta(data);
           onClose();
       }
   };

    const handleClose = () => {
            onClose();
          };

  return (

 // <Box sx={{mt: '100px' , ml:10, width: '75%'  }}>
  <Dialog onClose={onClose} open fullWidth={true} maxWidth={"sm"}>
    <DialogTitle>
        <Typography variant="h5">Nuovo Preventivo</Typography>
    </DialogTitle>
    <DialogContent>
        <div style={{ marginTop: '15px' }}></div>
        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack direction="column" alignItems="flex-start" spacing={2}>
                 <Stack direction="row" spacing={2} width="50%">
                <TextField
                    id="dataprev"
                    type="date"
                    label="Data"
                    fullWidth
                    margin="dense"
                    {...register('dataprev')}
                    onChange={(e) => setDataPrev(e.target.value)}
                />
                <Typography variant="inherit" color="textSecondary">
                    {errors.dataprev?.message}
                </Typography>
                 </Stack>
                <Stack direction="row" spacing={2} width="25%">
                <TextField
                    select
                    id="codditta"
                    label="Ditta"
                    margin="dense"
                    defaultValue="BS"
                    fullWidth
                    {...register('codditta')}
                    error={!!errors.codditta}
                    onChange={(e) => setCodDitta(Number(e.target.value))}
                >
                   <MenuItem key={2} value={2}>BS</MenuItem>
                   <MenuItem key={1} value={1}>IN4IT</MenuItem>
                </TextField>
                </Stack>
                <Stack spacing={2} width="100%">
                <Autocomplete
                    disablePortal
                    id="idcli"
                    value={ClientiDTOApiResponse?.results.find((item) => item.idcli === idcli) || null}
                    options={ClientiDTOApiResponse?.results ?? []}
                    onChange={(event, value) => { (value !== null && value.idcli != undefined) ? handleCliente(value.idcli) : console.log("No value selected") }}
                    renderInput={(params) => <TextField {...params} margin="dense" label="Seleziona Cliente" fullWidth />}
                />
                </Stack>
                <Stack direction="row" spacing={2} width="100%">
                <TextField
                    id="desprev"
                    label="Des.Preventivo"
                    fullWidth
                    margin="dense"
                    {...register('desprev')}
                    error={!!errors.desprev}
                />
                <Typography variant="caption" color="error">
                    {errors.desprev?.message}
                </Typography>
                </Stack>
                <Stack  direction="row" spacing={2} width="100%">
                <TextField
                    id="note"
                    label="Note"
                    fullWidth
                    margin="dense"
                    multiline
                    minRows={2}
                    {...register('note')}
                    error={!!errors.note}
                />
                <Typography variant="caption" color="error">
                    {errors.note?.message}
                </Typography>
                </Stack>
                {/*<Stack spacing={2} width="100%">*/}
                {/*<Autocomplete<VMPrevList>*/}
                {/*      options={VMPrevApiResponse?.results ?? []}*/}
                {/*      value={*/}
                {/*        VMPrevApiResponse?.results.find(*/}
                {/*          (item) => item.idvmprev === idvmprev*/}
                {/*        ) || null*/}
                {/*      }*/}
                {/*      getOptionLabel={(option) => option.label}*/}
                {/*      isOptionEqualToValue={(option, value) =>*/}
                {/*        option.idvmprev === value.idvmprev*/}
                {/*      }*/}
                {/*      onChange={(e, value) =>*/}
                {/*        value && setIdVMPrev(value.idvmprev)*/}
                {/*      }*/}
                {/*      renderInput={(params) => (*/}
                {/*        <TextField {...params} label="Seleziona VM" />*/}
                {/*      )}*/}
                {/*    />*/}
                {/*</Stack>*/}
                <Stack direction="row" spacing={2} width="25%">
                {isAdmin  && (
                    <TextField
                        select
                        id="flgtemp"
                        value={flgtemp}
                        label="Flag Temp"
                        fullWidth
                        margin="dense"
                        {...register('flgtemp')}
                        error={!!errors.flgtemp}
                        onChange={(e) => setFlgTemp(e.target.value)}
                        InputProps={{ style: { width: '100%', height: '40px' } }}
                    >
                        <MenuItem key={'Y'} value={'Y'}>Y</MenuItem>
                        <MenuItem key={'N'} value={'N'}>N</MenuItem>
                    </TextField>
                )}
                 </Stack>
                 <Stack direction="row" spacing={2} width="25%">
                {isAdmin  && (
                    <TextField
                        select
                        id="flgval"
                        value={flgtemp}
                        label="Flag Val"
                        fullWidth
                        margin="dense"
                        {...register('flgval')}
                        error={!!errors.flgval}
                        onChange={(e) => setFlgVal(e.target.value)}
                        InputProps={{ style: { width: '100%', height: '40px' } }}
                    >
                        <MenuItem key={'Y'} value={'Y'}>Y</MenuItem>
                        <MenuItem key={'N'} value={'N'}>N</MenuItem>
                    </TextField>
                )}
                 </Stack>
               </Stack>
            <Stack direction="row" justifyContent="flex-end" spacing={1} style={{ marginTop: '15px' }}>
                <Button color="primary" type="reset" variant="outlined">
                    CANCELLA
                </Button>
                <Button variant="contained" onClick={handleClose} color="error">CHIUDI</Button>
                <Button id="save" type="submit" color="primary" variant="contained"
                    onClick={() => handleButtonClick('save')}
                    disabled={isCreatingPrevTesta}
                    startIcon={
                        isCreatingPrevTesta ? (
                            <CircularProgress color="inherit" size={25} />
                        ) : null
                    }
                >
                    SALVA
                </Button>
            </Stack>
        </form>
    </DialogContent>
</Dialog>

 // </Box>
  );
};


export default PreventiviAdd;